<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-mt-36">
    <img src="~@/assets/shield_black.svg" alt="nrl" class="logo tw-w-24" />

    <button
      type="success"
      @click="redirect()"
      class="login-button tw-bg-green-700 hover:tw-bg-green-300 hover:tw-text-black tw-text-white tw-py-2 tw-px-8 tw-m-3 tw-h-10 tw-rounded tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center"
    >
      Login with NRL Account
    </button>
  </div>
</template>

<script>
import { getAuth0 } from "@/auth/auth0";

export default {
  name: "Login",
  props: {},
  created() {
    if (this.$store.getters["user/isAuthenticated"]) {
      this.$router.push("/").catch(() => {});
    }
  },
  data() {
    return {};
  },
  methods: {
    async redirect() {
      try {
        const auth0 = getAuth0();
        await auth0.loginWithRedirect({
          authorizationParams: {
            redirect_uri: process.env.VUE_APP_AUTH_REDIRECT_URI
          },
          appState: {
            target: this.$route.query.redirect || "/"
          }
        });
      } catch (err) {
        console.error("Auth0 login error:", err);
        this.$customError("Failed to login. Please try again.");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.wrap {
  height: 117px;
  max-height: 117px;
  text-align: center;
  margin-bottom: 0.5rem;
  .logo {
    max-height: 100%;
  }
}

.login-container {
  min-height: 100%;
  width: 100%;
  overflow: hidden;
  .login-form {
    text-align: center;
    position: relative;
    width: 400px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }
  .btn-container {
    margin-top: 50px;
  }
  .el-input {
    display: inline-block;
    width: 100%;
  }
  .el-button {
    display: table;
    white-space: normal;
    margin-top: 2rem;
    margin: 0 auto;
  }
  @media only screen and (max-width: $sm) {
    .login-form {
      width: auto;
    }
  }
}
</style>
